import { Id, Identifiable, OrganizationalUnit } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function assignResourcesToOrganizationalUnit(httpClient: HttpClient) {
  return (
    organizationalUnit: Identifiable<OrganizationalUnit>,
    resourceUuids: Id[],
  ) =>
    httpClient.sendHttpRequest<Id[]>({
      endpoint: `/organizational-units/${organizationalUnit.uuid}/resources/batch`,
      method: HttpMethods.POST,
      data: resourceUuids,
    });
}

export { assignResourcesToOrganizationalUnit };
